module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-building fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelExplanation[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelAddTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelTagName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagName),
      expression: "tagName"
    }],
    staticClass: "form-control align-left ",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tagName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelTagDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagDescription),
      expression: "tagDescription"
    }],
    staticClass: "form-control align-left",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tagDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default margin-bottom",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addUnitTag()
      }
    }
  }, [(_vm.tagIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddUnitTag[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTagListTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableTagColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(_vm.tableTagColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableTagColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tagList), function(Tag, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Tag.tagName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Tag.tagDescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteUnitTag(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])])])])])])]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c570d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cost_splitting/CompUnitTagsDisplay.vue
// module id = 1479
// module chunks = 4